module.exports = __webpack_public_path__ + "static/media/Boreal-Besties4.f7bbd7c9.jpg";